<template>
  <div class="c-input-text">
    <label
      :for="name"
      class="c-input-text__label c-input-label"
    >{{ label }}</label>
    <input
      :id="name"
      ref="field"
      :value="formattedValue"
      :placeholder="placeholder"
      :name="name"
      :class="{ 'errors c-input-field--error': hasError }"
      class="c-input-text__field c-input-field"
      type="tel"
      maxlen="10"
      v-bind="$attrs"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      @input="handleInput($event.target.value)"
    >
    <p
      :id="`${name}-error`"
      class="c-input-text__helper c-input-helper"
    >
      <slot name="helper" />
    </p>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'InputPhone',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Label',
    },
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedValue() {
      return this.formatValue(this.value);
    },
  },
  methods: {
    formatValue(value) {
      // return an empty string if there's not a value
      // default behavior with offline COAs in COAC
      if (!value) return '';
      return value
        .split('')
        .reduce((phone, char, indx) => {
          switch (indx) {
            case 0:
              return `(${char}`;
            case 3:
              return `${phone}) ${char}`;
            case 6:
              return `${phone}-${char}`;
            default:
              return `${phone}${char}`;
          }
        }, '');
    },
    handleInput(event) {
      const value = event
        .replace(/\D/g, '')
        .substring(0, 10);

      this.$emit('input', value);
      this.$refs.field.value = this.formatValue(value);
    },
  },
};
</script>
